import React from 'react';
import './Testimonials.css';
import farisAvatar from '../assets/avatars/faris.png';
import artieAvatar from '../assets/avatars/artie.png';
import maureenAvatar from '../assets/avatars/maureen.png';

const Testimonials = () => {
  const testimonials = [
    {
      rating: 5,
      text: "Finally a sports restaraunt that has excellent burgers, salads, sandwiches, many beers on tap AND great ambiance and a buzzy atmosphere where you can watch any sports game you want!!! I got the MC electric burger with fries and it was perfect….. They also have in-house soft serve which was 🤤  This restaraunt just opened up and already it's the go-to restaraunt for friends and family to either have great food and a night out or great drinks and apps and a day out meaning weekdays or weekends this place will hit the mark. Exactly what downtown San Carlos needed!!! 🙏",
      author: "Faris S.",
      avatar: farisAvatar
    },
    {
      rating: 5,
      text: "My server Dominique gave us a wonderful experience at Highlands on a rainy Friday evening. A new place, yet feels cozy and familiar. I would recommend to anyone who is looking for a great sports bar with a wonderful selection of beer.",
      author: "Artie H.",
      avatar: artieAvatar
    },
    {
      rating: 5,
      text: "Still in the soft opening phase, had a great time. It's the perfect spot to watch the game with TV's on every wall, but it's not distracting if you're just there to have a good time with friends. The menu is rather full for a soft opening, and I was so happy to see an abundance of \"GF\" and \"VEG\" on the menu without having to ask. Our waitress was super friendly, and our food came out at a very reasonable pace considering how busy it was. Looking forward to how this place progresses!",
      author: "Maureen N.",
      avatar: maureenAvatar
    },
  ];

  const renderStars = (rating) => {
    return "★".repeat(rating);
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2>What our customers<br />are saying</h2>
        <p className="testimonials-subtitle">Check out our most recent reviews!</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">{renderStars(testimonial.rating)}</div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="author">
                <img 
                  src={testimonial.avatar} 
                  alt={`${testimonial.author} avatar`} 
                  className="author-avatar"
                />
                <span className="author-name">{testimonial.author}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 